import Vue from "vue";

const faqSection = new Vue({
    el: '#app',
    data() {
        return {
            mobileActive: false,
            showaddForm: false,
            showDateFilter: false,
            messageType: 'private',
            showHeader: false,
            showDocumentsModal: false
        }
    },
});


